<div class="d-flex align-items-center justify-content-between mb-2">
    <h4>SMS Templates</h4>

    <div class="d-flex">
        <button
            class="btn btn-outline-secondary mb-1 me-2"
            type="button"
            *ngIf="numberOfSms < 6 || permissions.addMoreRemindersThanAllowed"
            (click)="onCancel.emit(); $event.stopPropagation();"
        >
            <icon-delete />
            {{ 'sms-content-form.cancelLabel' | translate }}
        </button>

        <button
            class="btn btn-outline-primary mb-1"
            type="button"
            [disabled]="saveDisable"
            (click)="save()"
        >
            <icon-save />
            {{ 'sms-content-form.saveLabel' | translate }}
        </button>
    </div>
</div>

<div class="card">
    <form class="card-body" [formGroup]="smsForm">
        <mat-tab-group 
            mat-stretch-tabs="false" 
            mat-align-tabs="start" 
            (selectedIndexChange)="onTab($event)" 
            [selectedIndex]="selectedTabIndex" 
            formArrayName="sms"
        >       
            <mat-tab  
                *ngFor="let controls of getControls(); let i = index" 
                [formGroupName]="i"
            >
                <ng-template mat-tab-label>
                    <div
                        *ngIf="i>1"
                        class="letter-spacing-normal"
                        [class.no-valid-sms]="(getDaysForReminder(i) <= getDaysForReminder(i-1))"
                    >
                        {{getLabel(i)}}
                    </div>

                    <div *ngIf="i<=1" class="letter-spacing-normal">{{getLabel(i)}}</div>
                </ng-template>

                <div class="form-ctn">
                    <div class="sms-content">
                        {{'sms-content-form.header' | translate}}
                    </div>
                    <div class="d-flex" *ngIf="selectedTabIndex > 0" style="margin-bottom:10px">
                        <div class="d-flex mt-1">
                            <label class="form-label">Number of days for this reminder</label>
                            <div style="display:flex;align-items: center;justify-content: center;"
                            ngbTooltip="Number of days that must pass before sending this reminder to the contact" placement="bottom">
                                <i class="fas info-icon fa-info-circle"></i>
                            </div>
                        </div>
                        <div class="d-flex">
                            <input 
                                name="newReminder" id="newReminder" 
                                formControlName="daysForReminder"
                                type="number"
                                [min]="i ? getDaysForReminder(i-1) : getDaysForReminder(i)"
                                pKeyFilter="pint"
                                class="form-control reminder-input">
                        </div>
                        <div *ngIf="i>1">
                            <div class="days-err-msg" *ngIf="(getDaysForReminder(i) <= getDaysForReminder(i-1))">*The amount of days for this reminder should be higher than the previous reminder</div>
                        </div>
                    </div>
                    <div>
                        <textarea rows="4" class="txtarea" formControlName= "smsBody">
            
                        </textarea>
                    </div>
                    <div class="mt-2 sms-info-message">
                        {{ 'sms-content-form.infoMessage' | translate }}
                        <div class="ml-2">
                            {{ 'sms-content-form.contactNameInfo' | translate }}
                            <br>
                            {{ 'sms-content-form.locationNameInfo' | translate }}
                        </div>
                    </div>
                </div>
            </mat-tab>

            <mat-tab disabled>
                <ng-template mat-tab-label>
                    <div class="d-flex" (click)="$event.stopPropagation();">
                        <button
                            class="btn btn-outline-primary"
                            *ngIf="numberOfSms < 6 || permissions.addMoreRemindersThanAllowed"
                            (click)="addReminder(); $event.stopPropagation();"
                        >
                            <icon-add-file />
                            Add Reminder
                        </button>
                    </div>
                </ng-template>
            </mat-tab>
        </mat-tab-group>

        <div class="add-remind-cnt">
            <button *ngIf="selectedTabIndex > 0" class="btn btn-outline-danger" (click)="deleteReminder()"> 
                <icon-delete />
                Delete Reminder
            </button>
        </div>

        <div class="act-btn-container text-center">
            <div class="sms-content justify-content-center col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <span>Message size: {{calculateMessageSize()}}</span>
                <div style="margin: -21px;" ngbTooltip="{{'sms-content-form.messageSize' | translate}}">
                    <i class="fas info-icon fa-info-circle"></i>
                </div>
            </div>
            <div class="sms-content justify-content-center col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <span>URL suffix size: {{calculateUrlSuffixSize()}}</span>
                <div style="margin: -21px;" ngbTooltip="{{'sms-content-form.suffixSize' | translate}}">
                    <i class="fas info-icon fa-info-circle"></i>
                </div>
            </div>
            <div class="sms-content justify-content-center col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <span>Total characters: {{calculateTotalCharacters()}}</span>
                <div style="margin: -21px;" ngbTooltip="{{'sms-content-form.totalCharacters' | translate}}">
                    <i class="fas info-icon fa-info-circle"></i>
                </div>
            </div>
            <div class="sms-content justify-content-center col-lg-3 col-md-4 col-sm-6 col-xs-12">
                <span>SMS needed: {{calculateSmsNeeded() <= 1 ? calculateSmsNeeded() : remainingCharacters() + '/' + calculateSmsNeeded()}}</span>
                <div style="margin: -21px;" ngbTooltip="{{'sms-content-form.smsNedded' | translate}}">
                    <i class="fas info-icon fa-info-circle"></i>
                </div>
            </div>
        </div>
    </form>

    <!-- <form [formGroup]="phoneForm">
        <div class="act-btn-container mb-3">
            <ngx-intl-tel-input
                [preferredCountries]="preferredCountries"
                [enableAutoCountrySelect]="false"
                [searchCountryFlag]="true"
                [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                [selectFirstCountry]="false" 
                [selectedCountryISO]="CountryISO.UnitedStates"
                [maxLength]="15" 
                [phoneValidation]="true" 
                [separateDialCode]="true"
                name="phoneNumberSms"
                formControlName="phoneNumberSms">
            </ngx-intl-tel-input>
            <button class="act-btn btn ml-3" (click)="sendTest()" [disabled]="phoneForm.invalid"> 
                {{'sms-content-form.sendTest' | translate}}
            </button>
        </div>
    </form> -->
</div>
